module.exports = __webpack_public_path__ + "media/honey-icons/icon-controls-5f1a95c0.svg";